import type { LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import CovidPanel from '../../panel/CovidPanel';
import MandatEmisApresPaiementPanel from '../../panel/InformationsRattachement/MandatEmisApresPaiementPanel';
import NumeroEmpruntPanel from '../../panel/NumeroEmpruntPanel';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';

class ProfilEcritureLieeEmpruntEmiseApEncaissementRecette extends BaseProfilRattachement {
	constructor(anneExercice: number) {
		super();
		this.code = PROFIL_ECRITURE.RECETTE.LIEE_EMPRUNT_EMISE_APRES_ENCAISSEMENT;
		this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.RECETTE.EMPRUNT;
		this.typePiece = TYPE_PIECE.RECETTE.EMIS_APRES_PAIE;
		this.imputation.articles = ['16'];
		this.naturePieceOrigine = NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE;
		this.exerRattachement = anneExercice.toString();
		this.idLigneOriginePes = 0;
		this.panels = [
			new CodeProduitLocalPanel(true),
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new MandatEmisApresPaiementPanel(true),
			new NumeroEmpruntPanel(true),
		];
	}

	checkLigne(ligne: LigneMouvement): ErrorField[] {
		return [
			...super.checkLigne(ligne),
			...this.checkExerRattachementAnterieurOuEgal(ligne),
			...this.checkIdLigneOriginePesNul(ligne),
		];
	}
}

export default ProfilEcritureLieeEmpruntEmiseApEncaissementRecette;
